import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Link } from "react-router-dom";
import moment from "moment";

import {
  GetAllPraktikum,
  GetAllPraktikumVerifikasi,
  reset,
} from "../../../features/praktikum/PraktikumSlice";

import {
  Card,
  Table,
  ButtonGroup,
  Button,
  InputGroup,
  Form,
} from "@themesberg/react-bootstrap";

import AdminLayout from "../../../layout/admin";
import { Header, PaginationComponent } from "../../../components/admin";

import {
  faSearch,
  faPlus,
  faEye,
  faTrash,
  faPrint,
  faCheck,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";
import axios from "axios";
import BASE_URL from "../../../api";
import { UserContext } from "../../../utils/ProtectedRoute";

const ListPraktikumPage = () => {
  const sortByList = [
    {
      id: "a.created_at",
      name: "Tanggal Pembuatan",
    },
    {
      id: "a.matkul_praktikum",
      name: "Matkul Praktikum",
    },
  ];

  const sortTypeList = [
    {
      id: "ASC",
      name: "Paling Awal",
    },
    {
      id: "DESC",
      name: "Paling Akhir",
    },
  ];

  const [query, setQuery] = useState("");
  const [sortBy, setSortBy] = useState("a.created_at");
  const [sortType, setSortType] = useState("DESC");
  const [row, setRow] = useState("10");
  const [page, setPage] = useState("1");
  const [isDone, setIsDone] = useState(false);

  const { pathname } = useLocation();

  const dispatch = useDispatch();
  const { data, isLoading } = useSelector((state) => state.praktikum);

  const token = localStorage.getItem("token");

  // get user data from context to validate which menu has shown and hide
  // for the current user
  const { userData } = useContext(UserContext);

  useEffect(() => {
    fetchDataListPraktikum();
  }, [dispatch, token, page, query, sortBy, sortType, row, isDone, userData]);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchDataListPraktikum();
  };

  const fetchDataListPraktikum = () => {
    dispatch(reset());
    // if it is mahasiswa
    if (userData?.id_role === "HA05") {
      dispatch(
        GetAllPraktikum({
          token: `${token}`,
          query: `?pageNumber=${page}&q=${query}&sortBy=${sortBy}&sortType=${sortType}&pageSize=${row}`,
        })
      );
    } else {
      dispatch(
        GetAllPraktikumVerifikasi({
          token: `${token}`,
          query: `?pageNumber=${page}&q=${query}&sortBy=${sortBy}&sortType=${sortType}&pageSize=${row}&isDone=${isDone}`,
        })
      );
    }
  };

  const handlePagination = (item) => {
    setPage(item);
  };

  const onClickDelete = (id) => {
    showAlertDialog({
      title: "Hapus?",
      msg: "Apakah anda yakin ingin menghapus ini?",
      confirmButtonText: "Hapus",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          if (id) {
            response = await axios.delete(`${BASE_URL}praktikum/${id}`, {
              headers: {
                Authorization: token,
              },
            });
            console.log("RESPONSE : ", response);
            hideLoadingDialog();
            showSuccessDialog({
              title: "Berhasil!",
              msg: "Berhasil menghapus data!",
            });
            fetchDataListPraktikum();
          } else {
            throw "id not found!";
          }
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menghapus data!",
          });
        }
      },
    });
  };

  return (
    <AdminLayout>
      <Header title="Praktikum">
        {userData?.id_role === "HA05" ? (
          <Button
            as={Link}
            variant="outline-primary"
            size="sm"
            to={`/${pathname.split("/")[1]}/create`}
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            Tambah
          </Button>
        ) : (
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => setIsDone(!isDone)}
          >
            <FontAwesomeIcon icon={isDone ? faCheck : faSpinner} className="me-2" />
            {isDone ? 'Selesai' : 'Belum Selesai'}
          </Button>
        )}
      </Header>
      <Card border="light" className="shadow-sm mb-4">
        <Card.Header>
          <div className="table-settings mb-4">
            <div className="d-flex justify-content-between">
              <form onSubmit={handleSearch}>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                  />
                </InputGroup>
              </form>
              <div className="d-flex gap-3">
                <Form.Group>
                  <Form.Select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                  >
                    {sortByList.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group>
                  <Form.Select
                    value={sortType}
                    onChange={(e) => setSortType(e.target.value)}
                  >
                    {sortTypeList.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          <Table
            responsive
            striped
            className="table-centered table-nowrap rounded mb-0"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-0">#</th>
                <th className="border-0">NIM</th>
                <th className="border-0">Nama</th>
                <th className="border-0">Matkul Praktikum</th>
                <th className="border-0">Tahun Ajaran</th>
                <th className="border-0">Status</th>
                <th className="border-0">Flag</th>
                <th className="border-0">Tanggal Dibuat</th>
                <th className="border-0">Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <th colSpan="9" style={{ textAlign: "center" }}>
                    Loading
                  </th>
                </tr>
              ) : (data?.items || []).length > 0 ? (
                data?.items?.map((item, i) => (
                  <tr key={item.id}>
                    <th>{((page-1)*10) + (i + 1)}</th>
                    <th>{item.nim}</th>
                    <th>{item.nama_pemohon}</th>
                    <th>{item.matkul_praktikum}</th>
                    <th>{item.tahun_ajaran} | {item.jenis_semester}</th>
                    <th>{item.str_status}</th>
                    <th>{item.flag_revisi ? 'REVISI' : item.is_rejected ? 'DITOLAK' : '-'}</th>
                    <th>
                      {moment(item.created_at).format(
                        "DD MMM YYYY HH:mm:ss"
                      )}
                    </th>
                    <th>
                      <ButtonGroup size="sm">
                        <Button as={Link} to={`/praktikum/detail/${item.id}`}>
                          <FontAwesomeIcon icon={faEye} />
                        </Button>
                        {/* BUTTON TO DOWNLOAD THE FILE */}
                        {item.path_dokumen_upload_final ? (
                          <Button
                            variant="info"
                            onClick={() => {
                              window.open(item.path_dokumen_upload_final, "_blank");
                            }}
                          >
                            <FontAwesomeIcon icon={faPrint} />
                          </Button>
                        ) : null}
                        {/* BUTTON TO DELETE */}
                        {item.status === "0" ? (
                          <Button
                            variant="danger"
                            onClick={() => onClickDelete(item.id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </Button>
                        ) : null}
                      </ButtonGroup>
                    </th>
                  </tr>
                ))
              ) : (
                <tr>
                  <th colSpan="9" style={{ textAlign: "center" }}>
                    Tidak ada data!
                  </th>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer>
          <div className="table-settings mb-4">
            <div className="d-flex justify-content-between align-items-center">
              <Form.Group>
                <Form.Select
                  placeholder="Row"
                  value={row}
                  onChange={(e) => setRow(e.target.value)}
                >
                  <option defaultValue="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                </Form.Select>
              </Form.Group>

              <PaginationComponent
                meta={data?.meta}
                handlePagination={(item) => handlePagination(item)}
              />
            </div>
          </div>
        </Card.Footer>
      </Card>
    </AdminLayout>
  );
};

export default ListPraktikumPage;
